import { api } from '@/services';
import { ApiResponse, ContribuinteDetalhado } from '../types';

export async function fetchListaContribuintes(
  snac?: string | null
): Promise<ContribuinteDetalhado[]> {
  const endpoint = snac
    ? `GestorContribuinte/Buscar?SNAC=${encodeURIComponent(snac)}`
    : 'GestorContribuinte/Buscar';

  const response = await api.get<ApiResponse<ContribuinteDetalhado[]>>(endpoint);
  return response.data || [];
}
